import { render, staticRenderFns } from "./VideosBlock.vue?vue&type=template&id=2d85fda3&scoped=true&"
import script from "./VideosBlock.vue?vue&type=script&lang=js&"
export * from "./VideosBlock.vue?vue&type=script&lang=js&"
import style0 from "./VideosBlock.vue?vue&type=style&index=0&id=2d85fda3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d85fda3",
  null
  
)

component.options.__file = "VideosBlock.vue"
export default component.exports